import React from "react";
import { Layout, Typography } from "antd";
import "../assets/styles/legal.scss";

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const legalDocuments = {
  privacy: {
    title: "Политика конфиденциальности",
    subtitle: "Privacy Policy",
    meta: ["Версия: 1.0"],
    sections: [
      {
        title: "1. Общие положения / General Provisions",
        paragraphs: [
          "Настоящая Политика конфиденциальности регулирует обработку персональных данных пользователей мобильного приложения и веб-платформы iTruck (далее - «Приложение»).",
          "This Privacy Policy governs the processing of personal data of users of the iTruck mobile application and web platform (hereinafter - the “Application”).",
        ],
      },
      {
        title: "2. Собираемые данные / Collected Data",
        paragraphs: [
          "Мы собираем и обрабатываем следующие данные пользователей:",
          "We collect and process the following user data:",
        ],
        lists: [
          [
            "ФИО водителей и грузовладельцев",
            "Паспортные данные водителей",
            "Лицензии и регистрационные документы компаний",
            "Телефонные номера",
            "Геолокационные данные водителей",
            "Документы, загружаемые пользователями в систему",
          ],
          [
            "Full names of drivers and cargo owners",
            "Drivers’ passport data",
            "Company licenses and registration certificates",
            "Phone numbers",
            "Drivers’ geolocation data",
            "Documents uploaded by users to the system",
          ],
        ],
      },
      {
        title: "3. Цели обработки / Purpose of Processing",
        paragraphs: [
          "Данные обрабатываются для:",
          "Data is processed for:",
        ],
        lists: [
          [
            "Предоставления доступа к сервису поиска и подбора транспорта",
            "Верификации личности и лицензий водителей и компаний",
            "Повышения безопасности перевозок",
            "Связи между водителями и грузовладельцами",
            "Улучшения качества сервиса и технической поддержки",
          ],
          [
            "Providing access to the transport search and matching service",
            "Verifying the identity and licenses of drivers and companies",
            "Ensuring transportation safety",
            "Facilitating communication between drivers and cargo owners",
            "Improving service quality and technical support",
          ],
        ],
      },
      {
        title: "4. Передача данных третьим лицам / Data Sharing",
        paragraphs: [
          "Мы можем передавать персональные данные:",
          "We may share personal data:",
        ],
        lists: [
          [
            "Партнерам и подрядчикам для предоставления услуг внутри платформы",
            "По запросу государственных органов в соответствии с законодательством Кыргызской Республики",
          ],
          [
            "With partners and contractors for providing services within the platform",
            "Upon request of government authorities in accordance with the laws of the Kyrgyz Republic",
          ],
        ],
      },
      {
        title: "5. Хранение данных / Data Retention",
        paragraphs: [
          "Данные хранятся на защищенных серверах в течение всего срока использования Приложения и 3 лет после удаления профиля, если иное не требуется законом.",
          "Data is stored on secure servers during the use of the Application and for 3 years after the account deletion, unless otherwise required by law.",
        ],
      },
      {
        title: "6. Права пользователей / User Rights",
        paragraphs: [
          "Пользователь имеет право:",
          "Users have the right to:",
        ],
        lists: [
          [
            "Запросить доступ к своим данным",
            "Исправить или обновить информацию",
            "Удалить свой аккаунт и данные (если это не противоречит законодательству)",
          ],
          [
            "Request access to their data",
            "Correct or update their information",
            "Delete their account and data (unless prohibited by law)",
          ],
        ],
      },
      {
        title: "7. Контакты / Contact",
        paragraphs: [
          "По всем вопросам, связанным с обработкой персональных данных, обращайтесь:",
          "For all inquiries related to personal data processing, please contact:",
          "E-mail: info@itruck.io",
        ],
      },
    ],
  },
  terms: {
    title: "Условия пользования",
    subtitle: "Terms of Use",
    meta: ["Версия: 1.0", "Дата вступления в силу: 17.10.2025"],
    sections: [
      {
        title: "1. Общие положения / General Provisions",
        paragraphs: [
          "Настоящие Условия регулируют использование мобильного приложения и веб-платформы iTruck. Регистрируясь или используя Приложение, вы соглашаетесь с данными Условиями.",
          "These Terms govern the use of the iTruck mobile application and web platform. By registering or using the Application, you agree to these Terms.",
        ],
      },
      {
        title: "2. Услуги / Services",
        paragraphs: [
          "iTruck предоставляет сервис для поиска, соединения и обмена информацией между грузовладельцами и водителями.",
          "iTruck provides a service for searching, connecting, and exchanging information between cargo owners and drivers.",
        ],
      },
      {
        title: "3. Ответственность / Liability",
        paragraphs: [
          "iTruck не является перевозчиком и не несет ответственности за действия сторон.",
          "Водители и грузовладельцы несут полную ответственность за предоставленные данные, документы и выполнение перевозок.",
          "iTruck is not a carrier and is not responsible for the actions of the parties.",
          "Drivers and cargo owners are fully responsible for the data, documents, and execution of shipments.",
        ],
      },
      {
        title: "4. Обязательства пользователей / User Obligations",
        paragraphs: [
          "Пользователь обязуется:",
          "The user agrees to:",
        ],
        lists: [
          [
            "Предоставлять достоверную информацию",
            "Не использовать платформу для незаконных действий",
            "Соблюдать правила и законодательство Кыргызской Республики",
          ],
          [
            "Provide accurate information",
            "Not use the platform for illegal activities",
            "Comply with the rules and laws of the Kyrgyz Republic",
          ],
        ],
      },
      {
        title: "5. Ограничение ответственности / Limitation of Liability",
        paragraphs: [
          "Компания iTruck не несет ответственности за убытки, возникшие в результате сбоев в работе сервиса, действий третьих лиц или неправомерного использования данных.",
          "iTruck shall not be liable for any losses resulting from service failures, actions of third parties, or unlawful use of data.",
        ],
      },
      {
        title: "6. Изменения условий / Changes to Terms",
        paragraphs: [
          "Компания оставляет за собой право изменять Политику и Условия, уведомляя пользователей не менее чем за 10 дней до вступления изменений в силу.",
          "The company reserves the right to modify this Policy and Terms, notifying users at least 10 days before the changes take effect.",
        ],
      },
    ],
  },
};

const LegalPage = ({ type }) => {
  const document = legalDocuments[type];

  return (
    <Layout className="legal-page">
      <Content className="legal-page__content">
        <div className="legal-page__header">
          <Text className="legal-page__brand">iTruck</Text>
          <Title level={1}>{document.title}</Title>
          <Text className="legal-page__subtitle">{document.subtitle}</Text>
          <div className="legal-page__meta">
            {document.meta.map((item) => (
              <Text key={item}>{item}</Text>
            ))}
          </div>
        </div>

        <div className="legal-page__document">
          {document.sections.map((section) => (
            <section className="legal-page__section" key={section.title}>
              <Title level={2}>{section.title}</Title>
              {section.paragraphs.map((paragraph) => (
                <Paragraph key={paragraph}>{paragraph}</Paragraph>
              ))}
              {section.lists?.map((list, index) => (
                <ul key={`${section.title}-${index}`}>
                  {list.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              ))}
            </section>
          ))}
        </div>
      </Content>
    </Layout>
  );
};

export default LegalPage;
